(function () {
  angular.module('binky.core.configuration.ready', ['binky.core.src2-migration']);
})();
